import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Import Montserrat Font */
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

  /* Reset CSS */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  *::before,
  *::after {
    box-sizing: inherit;
  }

  /* HTML e Body */
  html {
    font-size: 16px;
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    /* Safe areas (Android 15+/16 edge-to-edge + iOS notch) */
    padding-top: var(--safe-area-inset-top, env(safe-area-inset-top, 0px));
    padding-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
    padding-left: var(--safe-area-inset-left, env(safe-area-inset-left, 0px));
    padding-right: var(--safe-area-inset-right, env(safe-area-inset-right, 0px));
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.textPrimary};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
  }

  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-weight: ${props => props.theme.fonts.weights.semibold};
    line-height: 1.2;
    margin-bottom: 0.5rem;
  }

  h1 { font-size: 2rem; font-weight: ${props => props.theme.fonts.weights.bold}; }
  h2 { font-size: 1.75rem; }
  h3 { font-size: 1.5rem; }
  h4 { font-size: 1.25rem; }
  h5 { font-size: 1.125rem; }
  h6 { font-size: 1rem; }

  p { margin-bottom: 1rem; }

  /* Links */
  a {
    color: ${props => props.theme.colors.secondary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.normal};
    &:hover { color: ${props => props.theme.colors.primary}; text-decoration: underline; }
    &:focus { outline: 2px solid ${props => props.theme.colors.secondary}; outline-offset: 2px; }
  }

  /* Buttons */
  button {
    font-family: inherit; font-size: inherit; line-height: inherit; cursor: pointer; border: none; background: none; transition: ${props => props.theme.transitions.button};
    &:focus { outline: 2px solid ${props => props.theme.colors.secondary}; outline-offset: 2px; }
    &:disabled { cursor: not-allowed; opacity: 0.6; }
  }

  /* Inputs */
  input, textarea, select {
    font-family: inherit; font-size: inherit; line-height: inherit; color: inherit; border: none; background: none;
    &:focus { outline: none; }
    &::placeholder { color: ${props => props.theme.colors.textSecondary}; }
  }

  /* Animations */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  /* Utility classes */
  .fade-in {
    animation: fadeIn 0.3s ease;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .container {
      padding: 0 15px;
    }
  }
`;

export default GlobalStyles;


